import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'reconocimientos-barra',
  template: `
  <div class="header-mainInfo">
      <h1 class="">MiGLM - Reconocimientos</h1>
  </div>`,
})
export class ReconocimientosBarraComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
